import type { EmployeeDesignation, UserRole } from '../types';
import { hasEmployeeDesignation, isW2SalesEligibleRole } from './employeeDesignations';

/** Any W-2 role with the sales_rep designation may use PDF take-off features. */
export function canAccessTakeoffFeatures(args: {
  authRole: UserRole | string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (!isW2SalesEligibleRole(args.authRole)) return false;
  return hasEmployeeDesignation(args.designations, 'sales_rep');
}
